import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { RopFormFooter } from "../../../main/components/RopFormFooter";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import BaseButton from "../../../main/components/BaseButton";
import { AlreadyExistsError, ValidationError } from "../../../errors";
import { UsinasContext } from "../context/UsinasContextProvider";

export function UsinaFormFooter(props: {
  selectedStep: number;
  handleNext: () => void;
  handleBack: () => void;
  handleSave: () => Promise<void>;
}) {
  const { setNewUsina } = useContext(UsinasContext);
  const { handleNext, handleBack, handleSave } = props;
  const navigate = useNavigate();
  const [saveStatus, setSaveStatus] = useState<
    "idle" | "saving" | "success" | "error"
  >("idle");
  const [errorMessage, setErrorMessage] = useState("");

  const onCancel = () => {
    setNewUsina(null);
    navigate("/usinas");
  };
  const save = async () => {
    try {
      setSaveStatus("saving");
      await handleSave();
      setSaveStatus("success");
    } catch (error) {
      setSaveStatus("error");
      if (error instanceof AlreadyExistsError) {
        setErrorMessage(
          "Uma usina com o mesmo código ou nome já foi criada, por favor altere os dados e tente novamente."
        );
        return;
      }
      if (error instanceof ValidationError) {
        setErrorMessage(
          "Ocorreu um erro ao salvar a usina. Verifique se todos os campos obrigatórios estão preenchidos corretamente e tente novamente."
        );
        return;
      }

      setErrorMessage(
        "Ocorreu um erro a salvar a usina, por favor, tente novamente mais tarde"
      );
    }
  };

  const resetSaveStatus = () => {
    setSaveStatus("idle");
    setErrorMessage("");
  };
  return (
    <>
      <RopFormFooter
        steps={4}
        handleBack={handleBack}
        handleNext={handleNext}
        onCancel={onCancel}
        handleSave={save}
        modalText="Tem certeza que deseja cancelar o cadastro da Usina? "
        selectedStep={props.selectedStep}
      />
      <Dialog
        open={saveStatus === "success" || saveStatus === "error"}
        onClose={resetSaveStatus}
      >
        <DialogTitle>
          {saveStatus === "success" ? "Sucesso!" : "Erro!"}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {saveStatus === "success"
              ? "Nova Usina cadastrada com sucesso!"
              : errorMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <BaseButton
            sx={{ width: "fit-content" }}
            title="Fechar"
            onClick={resetSaveStatus}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
